<template>
<div class="side animate-box">
    <h1 v-if="id_design == '341'">Contact A Coach</h1>
    <h1 v-else-if="this.$store.state.companyData['id_country']+this.$store.state.companyData['id_language'] == '003001'">Contact A Counselor</h1>
    <p v-else-if="this.$store.state.companyData['id_company'] == '100679170'"><strong>Contact A Counselor</strong><br /><br /><sup><em>By contacting Aetna, you agree that any information you share will be kept confidential and will not be shared with McKesson and that your information will be stored in a secure location, which may be outside your home country.</em></sup></p>
    <h1 v-else><span v-html="lang_detail['cntrs114']"></span></h1>
    
    <div v-if="returnmsg==''">
        <p><span v-html="lang_detail['requiredDescription']"></span> (<span class="required_indicator">*</span>)</p>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="name" v-html="lang_detail['name']"></label>
                <input  type="text" id="name" class="form-control" v-model="name" ref="name" aria-label="Name" aria-required="true" @keypress="isLetterWithSpace($event)" >
                <!-- pattern="[a-zA-Z]+" oninvalid="setCustomValidity('Please enter on alphabets only. ')" title="Please Enter Valid Name"-->
            </div>
            <span id="name_validation_error" role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="phone" v-html="lang_detail['phone']+lang_detail['phoneformat']"></label>                
                <input @keypress="isNumberWithHyphen($event)" type="text" id="phone" class="form-control" v-model="phone" ref="phone" aria-label="Phone Number" aria-required="true" >
            </div>
            <span id="phone_validation_error" role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="country_list" v-html="lang_detail['country']"></label>
                <select name="country" v-model="country" id="country_list" class="form-control" ref="country" aria-label="Country" aria-required="true">
                    <option value=""></option>
                    <option value="Afghanistan" aria-label="Afganistan 2 of 196">Afghanistan</option>
                    <option value="Albania"  aria-label="Albania 3 of 196">Albania</option>
                    <option value="Algeria"  aria-label="Algeria 4 of 196">Algeria</option>
                    <option value="American Samoa"  aria-label="American Samoa 5 of 196">American Samoa</option>
                    <option value="Angola"  aria-label="Angola 6 of 196">Angola</option>
                    <option value="Antarctica"  aria-label="Antartica 7 of 196">Antarctica</option>
                    <option value="Argentina"  aria-label="Argentina 8 of 196">Argentina</option>
                    <option value="Armenia"  aria-label="Armenia 9 of 196">Armenia</option>
                    <option value="Aruba"  aria-label="Aruba 10 of 196">Aruba</option>
                    <option value="Australia"  aria-label="Australia 11 of 196">Australia</option>
                    <option value="Austria"  aria-label="Austria 12 of 196">Austria</option>
                    <option value="Azerbaijan"  aria-label="Azerbaijan 13 of 196">Azerbaijan</option>
                    <option value="Azores"  aria-label="Azores 14 of 196">Azores</option>
                    <option value="Bahamas"  aria-label="Bahamas 15 of 196">Bahamas</option>
                    <option value="Bahrain"  aria-label="Bahrain 16 of 196">Bahrain</option>
                    <option value="Baloush (Iran - Baluchistan Region)"  aria-label="Baloush Iran - Baluchistan Region 17 of 196">Baloush (Iran - Baluchistan Region)</option>
                    <option value="Bangladesh"  aria-label="Bangladesh 18 of 196">Bangladesh</option>
                    <option value="Barbados"  aria-label="Barbados 19 of 196">Barbados</option>
                    <option value="Belarus"  aria-label="Belarus 20 of 196">Belarus</option>
                    <option value="Belgium"  aria-label="Belgium 21 of 196">Belgium</option>
                    <option value="Belize"  aria-label="Belize 22 of 196">Belize</option>
                    <option value="Benin"  aria-label="Benin 23 of 196">Benin</option>
                    <option value="Bermuda"  aria-label="Bermuda 24 of 196">Bermuda</option>
                    <option value="Bolivia"  aria-label="Bolivia 25 of 196">Bolivia</option>
                    <option value="Bosnia &amp; Herzegovina"  aria-label="Bosnia and Herzegovina 26 of 196">Bosnia &amp; Herzegovina</option>
                    <option value="Botswana"  aria-label="Botswana 27 of 196">Botswana</option>
                    <option value="Brazil"  aria-label="Brazil 28 of 196">Brazil</option>
                    <option value="Bulgaria"  aria-label="Bulgaria 29 of 196">Bulgaria</option>
                    <option value="Burkina Faso"  aria-label="Burkina Faso 30 of 196">Burkina Faso</option>
                    <option value="Burundi"  aria-label="Burundi 31 of 196">Burundi</option>
                    <option value="Cambodia"  aria-label="Cambodia 32 of 196">Cambodia</option>
                    <option value="Cameroon"  aria-label="Cameroon 33 of 196">Cameroon</option>
                    <option value="Canada"  aria-label="Canada 34 of 196">Canada</option>
                    <option value="Cayman Islands"  aria-label="Cayman Island 35 of 196">Cayman Islands</option>
                    <option value="Central African Republic"  aria-label="Central African Republic 36 of 196">Central African Republic</option>
                    <option value="Chad"  aria-label="Chad 37 of 196">Chad</option>
                    <option value="Channel Islands"  aria-label="Channel Island 38 of 196">Channel Islands</option>
                    <option value="Chile"  aria-label="Chile 39 of 196">Chile</option>
                    <option value="China, PR"  aria-label="China PR 40 of 196">China, PR</option>
                    <option value="China - Hong Kong" aria-label="China - Hong kong 41 of 196">China - Hong Kong</option>
                    <option value="China - Macau" aria-label="China - Macau 42 of 196">China - Macau</option>
                    <option value="China - Taiwan" aria-label="China - Taiwan 43 of 196">China - Taiwan</option>

                    <option value="Colombia"  aria-label="Colombia 44 of 196">Colombia</option>
                    <option value="Congo" aria-label="Congo 45 of 196">Congo</option>
                    <option value="Costa Rica" aria-label="Costa Rica 46 of 196">Costa Rica</option>
                    <option value="Cote d'Ivoire" aria-label="Cote d'Ivoire 47 of 196">Cote d'Ivoire</option>
                    <option value="Croatia" aria-label="Croatia 48 of 196">Croatia</option>
                    <option value="Cuba" aria-label="Cuba 49 of 196">Cuba</option>
                    <option value="Cyprus" aria-label="Cyprus Rica 50 of 196">Cyprus</option>
                    <option value="Czech Republic" aria-label="Czech Republic 51 of 196">Czech Republic</option>
                    <option value="Denmark" aria-label="Denmark 52 of 196">Denmark</option>
                    <option value="Diego Garcia" aria-label="Diego Garcia 53 of 196">Diego Garcia</option>
                    <option value="Djibouti" aria-label="Djibouti 54 of 196">Djibouti</option>
                    <option value="Dominican Republic" aria-label="Dominican Republic 55 of 196">Dominican Republic</option>
                    <option value="East Timor" aria-label="East Timor 56 of 196">East Timor</option>
                    <option value="Ecuador" aria-label="Ecuador 57 of 196">Ecuador</option>
                    <option value="Egypt" aria-label="Egypt 58 of 196">Egypt</option>
                    <option value="El Salvador" aria-label="El Salvador 59 of 196">El Salvador</option>
                    <option value="Equatorial Guinea" aria-label="Equatorial Guinea 60 of 196">Equatorial Guinea</option>
                    <option value="Eritrea" aria-label="Eritrea 61 of 196">Eritrea</option>
                    <option value="Estonia" aria-label="Estonia 62 of 196">Estonia</option>
                    <option value="Ethiopia" aria-label="Ethiopia 63 of 196">Ethiopia</option>
                    <option value="Faeroe Islands" aria-label="Faeroe Islands 64 of 196">Faeroe Islands</option>
                    <option value="Fiji" aria-label="Fiji 65 of 196">Fiji</option>
                    <option value="Finland" aria-label="Finland 66 of 196">Finland</option>
                    <option value="France" aria-label="France 67 of 196">France</option>
                    <option value="Gabon" aria-label="Gabon 68 of 196">Gabon</option>
                    <option value="Gambia" aria-label="Gambia 69 of 196">Gambia</option>
                    <option value="Georgia" aria-label="Georgia 70 of 196">Georgia</option>
                    <option value="Germany" aria-label="Germany 71 of 196">Germany</option>
                    <option value="Ghana" aria-label="Ghana 72 of 196">Ghana</option>
                    <option value="Gibraltar" aria-label="Gibraltar 73 of 196">Gibraltar</option>
                    <option value="Greece" aria-label="Greece 74 of 196">Greece</option>
                    <option value="Greenland" aria-label="Greenland 75 of 196">Greenland</option>
                    <option value="Guam" aria-label="Guam 76 of 196">Guam</option>
                    <option value="Guatemala" aria-label="Guatemala 77 of 196">Guatemala</option>
                    <option value="Guinea" aria-label="Guinea 78 of 196">Guinea</option>
                    <option value="Guinea-Bissau" aria-label="Guinea Bissau 79 of 196">Guinea-Bissau</option>
                    <option value="Guyana" aria-label="Guyana 80 of 196">Guyana</option>
                    <option value="Haiti" aria-label="Haiti 81 of 196">Haiti</option>
                    <option value="Honduras" aria-label="Honduras 82 of 196">Honduras</option>
                    
                    <option value="Hungary" aria-label="Hungary 83 of 196">Hungary</option>
                    <option value="Iceland" aria-label="Iceland 84 of 196">Iceland</option>
                    <option value="India" aria-label="India 85 of 196">India</option>
                    <option value="Indonesia" aria-label="Indonesia 86 of 196">Indonesia</option>
                    <option value="Iran" aria-label="Iran 87 of 196">Iran</option>
                    <option value="Iraq" aria-label="Iraq 88 of 196">Iraq</option>
                    <option value="Ireland" aria-label="Ireland 89 of 196">Ireland</option>
                    <option value="Israel" aria-label="Israel 90 of 196">Israel</option>
                    <option value="Italy" aria-label="Italy 91 of 196">Italy</option>
                    <option value="Jamaica" aria-label="Jamaica 92 of 196">Jamaica</option>
                    <option value="Japan" aria-label="Japan 93 of 196">Japan</option>
                    <option value="Jordan" aria-label="Jordan 94 of 196">Jordan</option>
                    <option value="Kazakhstan" aria-label="Kazakhstan 95 of 196">Kazakhstan</option>
                    <option value="Kenya" aria-label="Kenya 96 of 196">Kenya</option>
                    <option value="Kosovo" aria-label="Kosova 97 of 196">Kosovo</option>
                    <option value="Kuwait" aria-label="Kuwait 98 of 196">Kuwait</option>
                    <option value="Kyrgyzstan" aria-label="Kyrgystan 99 of 196">Kyrgyzstan</option>
                    <option value="Laos" aria-label="Laos 100 of 196">Laos</option>
                    <option value="Latvia" aria-label="Latvia 101 of 196">Latvia</option>
                    <option value="Lebanon" aria-label="Lebanon 102 of 196">Lebanon</option>
                    <option value="Lesotho" aria-label="Lesotho 103 of 196">Lesotho</option>
                    <option value="Liberia" aria-label="Liberia 104 of 196">Liberia</option>
                    <option value="Libya" aria-label="Libya 105 of 196">Libya</option>
                    <option value="Lithuania" aria-label="Lithuania 106 of 196">Lithuania</option>
                    <option value="Luxembourg" aria-label="Luxembourg 107 of 196">Luxembourg</option>
                    
                    <option value="Macedonia" aria-label="Macedonia 108 of 196">Macedonia</option>
                    <option value="Madagascar" aria-label="Madagascar 109 of 196">Madagascar</option>
                    <option value="Malawi" aria-label="Malawi 110 of 196">Malawi</option>
                    <option value="Malaysia" aria-label="Malaysia 111 of 196">Malaysia</option>
                    <option value="Mali, Republic of" aria-label="Mali, Republic of 112 of 196">Mali, Republic of</option>
                    <option value="Malta" aria-label="Malta 113 of 196">Malta</option>
                    <option value="Mauritania" aria-label="Mauritania 114 of 196">Mauritania</option>
                    <option value="Mauritius" aria-label="Mauritius 115 of 196">Mauritius</option>
                    <option value="Mexico" aria-label="Mexico 116 of 196">Mexico</option>
                    <option value="Moldova" aria-label="Moldova 117 of 196">Moldova</option>
                    <option value="Monaco" aria-label="Monaco 118 of 196">Monaco</option>
                    <option value="Mongolia" aria-label="Mangolia 119 of 196">Mongolia</option>
                    <option value="Montenegro" aria-label="Montenegro 120 of 196">Montenegro</option>
                    <option value="Morocco" aria-label="Morocco 121 of 196">Morocco</option>
                    <option value="Mozambique" aria-label="Mozambique 122 of 196">Mozambique</option>
                    <option value="Myanmar (Burma)" aria-label="Myanmar Burma 123 of 196">Myanmar (Burma)</option>
                    <option value="Namibia" aria-label="Namibia 124 of 196">Namibia</option>
                    <option value="Nepal" aria-label="nepal 125 of 196">Nepal</option>
                    <option value="Netherlands" aria-label="Netherlands 126 of 196">Netherlands</option>
                    <option value="New Zealand" aria-label="New Zealand 127 of 196">New Zealand</option>
                    <option value="Nicaragua" aria-label="Nicaragua 128 of 196">Nicaragua</option>
                    <option value="Nigeria" aria-label="Nigeria 129 of 196">Nigeria</option>
                    <option value="North Korea" aria-label="North Korea 130 of 196">North Korea</option>
                    <option value="Norway" aria-label="Norway 131 of 196">Norway</option>
                    <option value="Okinawa" aria-label="Okinawa 132 of 196">Okinawa</option>
                    <option value="Oman" aria-label="Oman 133 of 196">Oman</option>
                    <option value="Pakistan" aria-label="Pakistan 134 of 196">Pakistan</option>
                    <option value="Palestinian Territories" aria-label="Palestinian Territories 135 of 196">Palestinian Territories</option>
                    <option value="Panama" aria-label="Panama 136 of 196">Panama</option>
                    <option value="Papua New Guinea" aria-label="Papua New Guinea 137 of 196">Papua New Guinea</option>
                    <option value="Paraguay" aria-label="Paragua 138 of 196">Paraguay</option>
                    <option value="Peru" aria-label="Peru 139 of 196">Peru</option>
                    <option value="Philippines" aria-label="Philippines 140 of 196">Philippines</option>
                    <option value="Poland" aria-label="Poland 141 of 196">Poland</option>
                    <option value="Portugal" aria-label="Portugal 141 of 196">Portugal</option>
                    <option value="Puerto Rico" aria-label="Puerto Rico 142 of 196">Puerto Rico</option>
                    <option value="Qatar" aria-label="Qatar 143 of 196">Qatar</option>
                    <option value="Romania" aria-label="Romania 144 of 196">Romania</option>
                    <option value="Russia" aria-label="Rusiia 145 of 196">Russia</option>
                    <option value="Rwanda" aria-label="Rwanda 146 of 196">Rwanda</option>
                    <option value="Saudi Arabia" aria-label="Saudi Arabia 147 of 196">Saudi Arabia</option>
                    <option value="Senegal" aria-label="Senegal 148 of 196">Senegal</option>
                    <option value="Serbia" aria-label="Serbia 149 of 196">Serbia</option>
                    <option value="Seychelles" aria-label="Seychelles 150 of 196">Seychelles</option>
                    <option value="Sierra Leone" aria-label="Sierra Leone 151 of 196">Sierra Leone</option>
                    <option value="Singapore" aria-label="Singapore 152 of 196">Singapore</option>
                    <option value="Slovakia" aria-label="Slovakia 153 of 196">Slovakia</option>
                    <option value="Slovenia" aria-label="Slovenia 154 of 196">Slovenia</option>
                    <option value="Somalia" aria-label="Somalia 155 of 196">Somalia</option>
                    <option value="Somaliland" aria-label="Somaliland 156 of 196">Somaliland</option>
                    <option value="South Africa" aria-label="South Africa 157 of 196">South Africa</option>
                    <option value="South Korea" aria-label="South Korea 158 of 196">South Korea</option>
                    <option value="Spain" aria-label="Spain 159 of 196">Spain</option>
                    <option value="Sri Lanka" aria-label="Sri Lanka 160 of 196">Sri Lanka</option>
                    <option value="St. Lucia" aria-label="St. Lucia 161 of 196">St. Lucia</option>
                    <option value="St. Maarten" aria-label="St. Maarten 162 of 196">St. Maarten</option>
                    <option value="Sudan" aria-label="Sudan 163 of 196">Sudan</option>
                    <option value="Suriname" aria-label="Suriname 164 of 196">Suriname</option>
                    <option value="Swaziland" aria-label="Swaziland 165 of 196">Swaziland</option>
                    <option value="Sweden" aria-label="Sweden 166 of 196">Sweden</option>
                    <option value="Switzerland" aria-label="Switzerland 167 of 196">Switzerland</option>
                    <option value="Syria" aria-label="Syria 168 of 196">Syria</option>
                    
                    <option value="Tajikistan" aria-label="Tajikistan 169 of 196">Tajikistan</option>
                    <option value="Tanzania" aria-label="Tanzania 170 of 196">Tanzania</option>
                    <option value="Thailand" aria-label="Thailand 171 of 196">Thailand</option>
                    <option value="Timor-Leste (East Timor)" aria-label="Timor Leste East Timor 172 of 196">Timor-Leste (East Timor)</option>
                    <option value="Togo (Togolese Republic)" aria-label="Togo Togolese Republic 173 of 196">Togo (Togolese Republic)</option>
                    <option value="Trinidad &amp; Tobago" aria-label="Trinidad and Tbago 174 of 196">Trinidad &amp; Tobago</option>
                    <option value="Tunisia" aria-label="Tunisia 175 of 196">Tunisia</option>
                    <option value="Turkey" aria-label="Turkey 176 of 196">Turkey</option>
                    <option value="Turkmenistan" aria-label="Turkmenistan 177 of 196">Turkmenistan</option>
                    <option value="Turks &amp; Caicos Islands" aria-label="Turks and Caicos Island 178 of 196">Turks &amp; Caicos Islands</option>
                    <option value="UAE" aria-label="UAE 179 of 196">UAE</option>
                    <option value="Uganda" aria-label="Uganda 180 of 196">Uganda</option>
                    <option value="UK - England" aria-label="UK - England 181 of 196">UK - England</option>
                    <option value="UK - Northern Ireland" aria-label="UK - Northern Ireland 182 of 196">UK - Northern Ireland</option>
                    <option value="UK - Scotland" aria-label="Uk - Scotland 183 of 196">UK - Scotland</option>
                    <option value="UK - Wales" aria-label="UK - Wales 184 of 196">UK - Wales</option>
                    <option value="Ukraine" aria-label="Ukraine 185 of 196">Ukraine</option>
                    <option value="Uruguay" aria-label="Uruguay 186 of 196">Uruguay</option>
                    <option value="USA" aria-label="USA 187 of 196">USA</option>
                    <option value="Uzbekistan" aria-label="Uzbekistan 188 of 196">Uzbekistan</option>
                    <option value="Venezuela" aria-label="Venezuela 189 of 196">Venezuela</option>
                    <option value="Vietnam" aria-label="Vietnam 190 of 196">Vietnam</option>
                    <option value="Virgin Islands - British" aria-label="Virgin Islands - British 191 of 196">Virgin Islands - British</option>
                    <option value="Virgin Islands - US" aria-label="Virgin Islands - US 192 of 196">Virgin Islands - US</option>
                    <option value="Yemen" aria-label="Yemen 193 of 196">Yemen</option>
                    <option value="Zambia" aria-label="Zambia 194 of 196">Zambia</option>
                    <option value="Zimbabwe" aria-label="Zimbabwe 195 of 196">Zimbabwe</option>
				</select>
            </div>
            <span id="country_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <label for="emaill" v-html="lang_detail['email']"></label>
                <input type="email" @keypress="htmlfiveValidationErr($event)" id="emaill" class="form-control" v-model="email" ref='email' aria-label="Email" title="enter valid email">
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <label for="bestTime" v-html="lang_detail['phoneTimes']"></label>
                <select name="bestTime" id="bestTime" v-model="best_time" class="form-control" ref="bestTime" aria-label="preferred time for contact">
                    <option v-html="lang_detail['anytime']" selected aria-label="anytime 1 of 4"></option>
                    <option v-html="lang_detail['morning']" aria-label="morning 2 of 4"></option>
                    <option v-html="lang_detail['afternoon']" aria-label="afternoon 3 of 4"></option>
                    <option v-html="lang_detail['evening']" aria-label="evening 4 of 4"></option>
                </select>            
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="phoneMsg" v-html="lang_detail['phoneMsg']"></label>
                <select name="phoneMsg" id="phoneMsg" v-model="phoneMsg" class="form-control" ref="phoneMsg" aria-label="Message on phone" aria-required="true">
                    <option :value="lang_detail['no']" selected aria-label="no 1 of 2">{{lang_detail['no']}}</option>
                    <option :value="lang_detail['yes']" aria-label="yes 2 of 2">{{lang_detail['yes']}}</option>
                </select>
                <span id="phoneMsg_validation_error" role="alert"></span>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="message" v-html="lang_detail['reason']"></label>
                <textarea id="message" rows="20" cols="20" class="form-control" v-model="message" ref="message" aria-label="Reason for inquiry" aria-required="true" maxlength="1500" ></textarea>
            </div>
            <span id="message_validation_error" role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <input type="checkbox" name="fterms" id="fterms" aria-required="true"  v-model="fterms" ref="fterms" aria-label="Accept terms and conditions">&nbsp;<span v-html="lang_detail['terms_check']"></span>
            </div>
            <span id="fterms_validation_error" role="alert"></span>
        </div>
        <div class="row form-group">
            <p></p>
        </div> 
        <div class="row form-group hhcap">
            <vue-hcaptcha :sitekey="$store.state.HC_SITE_KEY"  @verify="onVerify" @expired="onExpire" @error="onError"></vue-hcaptcha>
            <span id="hccaptcha_validation_error" role="alert"></span>
        </div>      
        <div class="form-group">
            <button type="button" :disabled="disablefdbtn" class="btn submit btn-primary" @click="sendForm()" v-html="lang_detail['submit']"></button>
        </div>
    </div>
    <p v-else v-html="returnmsg" role="alert"></p>
</div>    
</template>
<script>
import axios from 'axios';
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
export default {
    name: 'ContactCounselor',
    data(){
        return{
            lang_detail:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            languageData:this.$store.state.languageData,
            fterms:'',message:'',email:'',name:'',returnmsg:'',        
            phone:'',
            country:'',
            best_time:'',
            id_design:localStorage.id_design,
            phoneMsg:'',
            verified: false,
            expired: false,
            token: null,
            eKey: null,
            error: null,
            disablefdbtn:false           
        };        
    },
    components:{
        VueHcaptcha       
    },
    mounted :function(){
        this.getlangVar()
    },
    created:function(){
    },
    watch: {
        name: function() {
            this.validateFormRemoveMarkers('name_validation_error');               
        },
        phone: function() {
            this.validateFormRemoveMarkers('phone_validation_error');               
        },        
        country: function() {
            this.validateFormRemoveMarkers('country_validation_error');               
        },        
        message: function() {
            this.validateFormRemoveMarkers('message_validation_error');               
        },        
        fterms: function() {
            this.validateFormRemoveMarkers('fterms_validation_error');               
        },
        phoneMsg: function(){
            this.validateFormRemoveMarkers('phoneMsg_validation_error');
        },
        verified: function() {
            this.validateFormRemoveMarkers('hccaptcha_validation_error');               
        }
    },
	methods:{
        sendForm(){            
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                   
                }
            }
            const formData = new FormData()
            formData.append('name', this.name)
            formData.append('phone', this.phone)
            formData.append('email', this.email)
            formData.append('country', this.country)
            formData.append('bestTime', this.best_time)
            formData.append('message', this.message)
            formData.append('terms', this.fterms)
            formData.append('id_company', this.$store.state.companyData['id_company'])
            formData.append('id_language', this.$store.state.companyData['id_language'])
            formData.append('name_company', this.$store.state.companyData['name_company'])
            formData.append('id_eap', this.$store.state.companyData['id_eap'])
            formData.append('id_country', this.$store.state.companyData['id_country'])
            formData.append('name_eap', this.$store.state.companyDataInfo['name_eap'])
            formData.append('ucms_company', this.$store.state.companyDataInfo['ucms_company'])
            formData.append('phoneMsg',this.phoneMsg)
            formData.append('hc_token', this.token)
            
           var validateForm = this.validateForm(this.name,this.phone,undefined,this.country,undefined,undefined,this.message,undefined,this.fterms,this.phoneMsg,undefined,undefined,undefined,undefined,undefined,undefined,undefined,this.verified);           
           if(!validateForm){
                this.disablefdbtn=true;
                axios.post(this.$store.state.FORM_ACTION_DOMAIN+'/new_eesite_forms/contact_counselor_form.php',formData,config)
                .then(response => {                    
                    if(response === undefined || response.length == 0 ){
                        this.returnmsg='! Something went wrong, Please try again'
                    }
                    else{
                        this.returnmsg = response.data;
                        this.web_hits('contact_counselor_form_submit_clicked');                          
                    }                    
                })
                .catch(() => {                    
                    this.returnmsg='Try after sometime'
                });
            }
        },
        getlangVar(){
            document.querySelector('title').setAttribute("aria-busy", "true");
            var api_private_key=this.get_api_key_mix('lams')
            axios.get(this.$store.state.apiUrl+'/language_terms',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    privatekey:api_private_key,
                    id_company:this.$store.state.companyData['id_company'],
                    id_country:this.$store.state.companyData['id_country']                  
                }
            })
            .then(response => { 
                response = response.data;
                this.lang_detail = response;
                if(this.lang_detail['cntr114']=="" || this.lang_detail['cntr114']==undefined){
                    var titleValue="Contact A Counselor";
                }
                else{
                    var titleValue =this.lang_detail['cntr114'];
                }

                if(this.id_design == '341'){
                    var titleValue ="Contact A Coach";
                }
              
                var home = this.lang_detail['d00'];
                this.$announcer.set(this.decodeHtmlLang(titleValue)+' | '+this.$store.state.companyData['name_company']);
                document.title = this.decodeHtmlLang(titleValue)+' | '+this.$store.state.companyData['name_company'];             
            })
            .catch(() => {
                this.main_content = []
            });
        },
        onVerify(token, ekey) {
            this.verified = true;
            this.token = token;
            this.eKey = ekey;
        },
        onExpire() {
            this.verified = false;
            this.token = null;
            this.eKey = null;
            this.expired = true;
        },
        onError(err) {
            this.token = null;
            this.eKey = null;
            this.error = err;
        }
    }
};
</script>
<style scoped>
.form-group{
    margin-bottom: 40px;
}
.side{
   margin-left:15px; 
}

.side .submit{
    right: 20px !important;
}
@media screen and (max-width: 350px) {
    .side{
        margin-left:18px; 
    }
    .side .submit{
        right: 30px !important;
    }
}

.dynamic_form_error_required{
    padding-left:15px !important;
    color:#FF0000 !important;    
}
.required_indicator {
    font-family: Verdana;
    font-size: 14px;
    color: red;
}
.form-control {
    -webkit-appearance: auto;
    -moz-appearance: auto;
    appearance: auto;
}
/* [aria-required=true] {
  border: red thin solid;
} */
.hhcap{
    padding-left: 1em;
}
</style>